<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">{{routeName}}</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/gifts" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
            <form @submit.prevent="createGift">
                <div class="row justify-content-md-center">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-md-4">
                              <fg-input type="text"
                                        v-model="gift.gifteeUuid"
                                        label="Code"
                                        placeholder="Enter Code"
                                        v-validate="rules.gifteeUuid"
                                        data-vv-name="Code"
                                        cus-name="Code"
                                        :has-errors="errors"
                                        :is-fields="fields">
                              </fg-input>
                            </div>
                            <div class="col-md-4" v-if="types.length">
                                <fg-select
                                        v-model="type"
                                        label="Type"
                                        v-validate="rules.type"
                                        data-vv-name="type"
                                        cus-name="type"
                                        :has-errors="errors"
                                        :is-fields="fields"
                                        :list="types"
                                        selectedKey="id"
                                        >
                                </fg-select>
                            </div>

                          <div class="col-4" v-if="packages.length">
                            <fg-select
                              v-model="gift.packageId"
                              label="Package"
                              v-validate="rules.packageId"
                              data-vv-name="package"
                              cus-name="package"
                              :has-errors="errors"
                              :is-fields="fields"
                              :list="packages"
                              selectedKey="packageId"
                            >
                            </fg-select>
                          </div>

                          <div class="col-4" v-if="corporationsList.length">
                            <fg-select
                              v-model="gift.corporationId"
                              label="Corporation"
                              v-validate="rules.corporationId"
                              data-vv-name="corporation"
                              cus-name="corporation"
                              :has-errors="errors"
                              :is-fields="fields"
                              :list="corporationsList"
                              selectedKey="corporationId"
                            >
                            </fg-select>
                          </div>
                          <div class="col-4" v-if="customDateFlags.length">
                            <fg-select
                              v-model="gift.trialExpiryDateType"
                              label="Gift Expiry Settings"
                             :is-fields="fields"
                              :list="customDateFlags"
                              selectedKey="id"
                            >
                            </fg-select>
                          </div>
                          <div class="col-md-4" v-if="gift.trialExpiryDateType === '1'">
                            <label>Set Expiry Date</label>
                            <datetime v-model="gift.trialEndDateCustom"
                                      input-class="form-control"
                                      placeholder="Choose a Date"
                                      type="date"
                                      input-format="DD-MM-YYYY"
                                      :min-datetime="startDate"
                                      auto-continue required>

                            </datetime>
                          </div>

                          <div class="col-md-4" >
                            <fg-select
                              v-model="gift.preValidate"
                              label="User Validation Rules"
                              :is-fields="fields"
                              :list="validationFlags"
                              selectedKey="id"
                            >
                            </fg-select>
                          </div>
                          <div class="col-md-4">
                            <fg-select
                              v-model="gift.skipInterestPage"
                              label="Interest Page After Signup"
                              :is-fields="fields"
                              :list="interestFlags"
                              selectedKey="id"
                            >
                            </fg-select>
                          </div>
                          <div class="col-md-5">
                            <fg-input type="text"
                                      v-model="gift.landingPage "
                                      label="Default Landing Page after Singup"
                                      placeholder="(e.g) /corporation/mycommunity or /mytone"
                            >
                            </fg-input>
                          </div>
                          <div class="col-md-3">
                            <fg-input type="text"
                                      v-model="gift.button_label_01 "
                                      label="Redeem Button Tittle"
                                      placeholder="Redeem Button Title"
                            >
                            </fg-input>
                          </div>
                          <div class="col-md-4" >
                            <fg-select
                              v-model="gift.trialExpiryMsgFlag"
                              label="Trial Expiry Flags"
                              :is-fields="fields"
                              :list="trialFlags"
                              selectedKey="id"
                            >
                            </fg-select>
                          </div>
                          <div class="col-md-12">
                            <fg-input type="text"
                                      v-model="gift.welcomeMessage "
                                      label="Welcome Message"
                                      placeholder="Welcome Message"
                            >
                            </fg-input>
                          </div>
                          <div class="col-md-12">
                            <fg-input type="text"
                                      v-model="gift.signupGiftDesc "
                                      label="Gift Redeem Package Description"
                                      placeholder="Gift Redeem Package Description"
                            >
                            </fg-input>
                          </div>
                          <div class="col-md-12">
                            <fg-input type="text"
                                      v-model="gift.panelHeading1 "
                                      label="Panel Title"
                                      placeholder="Panel Title"
                            >
                            </fg-input>
                          </div>
                          <div class="col-md-12">
                            <fg-input type="text"
                                      v-model="gift.panelHeading2 "
                                      label="Panel Description"
                                      placeholder="Panel Description"
                            >
                            </fg-input>
                          </div>
                          <div class="col-md-12">
                            <fg-input type="text"
                                      v-model="gift.panelBullet1 "
                                      label="Panel Bullet 1 Text"
                                      placeholder="Panel Bullet 1 Text"
                            >
                            </fg-input>
                          </div>
                          <div class="col-md-12">
                            <fg-input type="text"
                                      v-model="gift.panelBullet2 "
                                      label="Panel Bullet 2 Text"
                                      placeholder="Panel Bullet 2 Text"
                            >
                            </fg-input>
                          </div>
                          <div class="col-md-12">
                            <fg-input type="text"
                                      v-model="gift.panelBullet3 "
                                      label="Panel Bullet 3 Text"
                                      placeholder="Panel Bullet 3 Text"
                            >
                            </fg-input>
                          </div>
                          <div class="col-md-12">
                            <fg-input type="text"
                                      v-model="gift.panelBullet4 "
                                      label="Panel Bullet 4 Text"
                                      placeholder="Panel Bullet 4 Text"
                            >
                            </fg-input>
                          </div>
                          <div class="col-md-12">
                            <fg-input type="text"
                                      v-model="gift.panelBullet5 "
                                      label="Panel Bullet 5 Text"
                                      placeholder="Panel Bullet 5 Text"
                            >
                            </fg-input>
                          </div>
                          <div class="col-md-12">
                            <fg-input type="text"
                                      v-model="gift.panelBullet6 "
                                      label="Panel Bullet 6 Text"
                                      placeholder="Panel Bullet 6 Text"
                            >
                            </fg-input>
                          </div>
                        </div>
                    </div>
                    <div class="col-6 text-center">
                        <button type="submit" :disabled="errors.any()" class="btn btn-primary btn-fill btn-block">
                            Create Gift
                        </button>
                    </div>
                </div>
                <div class="clearfix"></div>
            </form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import moment from 'moment'
    export default {
        name: 'CreateGift',
        data () {
          let dateTime = new Date();
        return {
            trialExpiryFlag: 0,
            type: '',
            corporations: [],
            corporationsList: [],
            packages: [],
            startDate: dateTime.toISOString(),
            gift: {
              trialExpiryDateType: 2,
              trialExpiryMsgFlag: 1,
              gifteeUuid: '',
              userId: 10,
              gifteeLastName: null,
              gifteeFirstName: null,
              gifteeEmail: null,
              deliveryDate: null,
              redeemDate: null,
              packageId: 1,
              deliveryMessage: null,
              createdDate: null,
              redeemUserId: null,
              corporationId: 0,
              corporationName: null,
              trialEndDateCustom: null,
              preValidate: 0,
              skipInterestPage: 0,
              landingPage: '/corporation/mycommunity',
              welcomeMessage: '',
              button_label_01: '',
              signupGiftDesc: '',
              panelHeading1: 'Your Plan',
              panelHeading2: 'What You Get',
              panelBullet1: 'Access to highly credentialed experts for on-demand guidance and coaching to help you grow personally and professionally',
              panelBullet2: 'Over 1200 bite-sized original videos designed for the working woman who is short on "free time"',
              panelBullet3: 'An open invitation to all live streaming events with our credentialed experts and career coaching sessions. Learn and ask questions with other Tone members',
              panelBullet4: 'A personalized experience. TONE is self-directed, so you go at your own pace and just watch what you want',
              panelBullet5: 'Custom communications:<br>TONE Teasers: customized emails serve up videos selected just for you<br>TONE Takeaways: reminder emails reinforce the skills you learn and help make it stick',
              panelBullet6: 'Membership to a vibrant community of like-minded professional women who share your passions, challenges and goals. Learn from each other in live-streaming and interactive coaching sessions'
            },
            types: [{name:'Select Type'}, {id:1, name:'Corporation'}, {id:0, name:'Individual'}],
            interestFlags: [{id:0, name:'Enable Interest Page after Singup'}, {id:1, name:'Bypass Interest Page after signup'}],
          validationFlags: [{id:1, name:'Validate user straighaway '}, {id:0, name:'User Validation via Email'}],
          trialFlags: [{id:1, name:'Show Trial Expiry Message'}, {id:0, name:'Do not show Trial Expiry Message'}],
          customDateFlags: [{id: 1, name:'Custom Expiry Date'}, {id:2, name:'Package based Expiry Date'}],
            rules: {
                gifteeUuid : {required: true},
                corporationId : {required: true},
                packageId : {required: true},
                deliveryMessage : {required: false},
                type : {required: true}
            },
        }
    },
    methods: {
        createGift () {
            this.$validator.validateAll().then((result) => {
                if(result){
                  if (this.gift.trialExpiryDateType === 2) {
                    this.gift.trialEndDateCustom = null
                  } else {
                    this.gift.trialEndDateCustom = moment(this.gift.trialEndDateCustom).format('YYYY-MM-DD')
                  }
                  // this.gift.trialEndDateCustom = moment(this.gift.trialEndDateCustom).format('YYYY-MM-DD')
                  this.gift.gifteeUuid = this.gift.gifteeUuid.replace(/\s/g, '').toUpperCase()
                    console.log("this.gift : ", this.gift);
                  let createGift = () => {
                    this.$store.dispatch('ADD_GIFT', this.gift)
                      .then((res) => {
                        console.log("ADD_GIFT res : ", res);
                        if(res) this.showPopup('Success!', 'Gift is successfully created', 'success', ()=> this.$router.push('/admin/gifts'))
                        else this.showPopup('Error!', 'Unable to process.', 'error')
                      })
                      .catch(err => {
                        this.showPopup('Error!', 'Gift Code is already exitst.', 'error')
                        console.log("ADD_GIFT API error : ", err);
                      })
                  };
                  createGift();
                }

            })
        },
        showPopup(title, msg, popupType, cb){
            this.$swal( title, msg, popupType
            ).then(res => {
                        cb && cb();
                        return res
                    })
        },
        capitalizeFirstLetter (string) {
            return string.charAt(0).toUpperCase() + string.slice(1)
        },
        fetchCorporations () {
          this.$store.dispatch('FETCH_CORPORATIONS')
            .then((res) => {
              res.unshift({name: "Select an option"});
              this.corporations = res;
              console.log("this.corporations : ", this.corporations);
            })
            .catch(err => {
              console.log("API error : ", err);
            }),
            (err) => {
              console.log("err : ", err);
            }
        },

        fetchPackages () {
          this.$store.dispatch('FETCH_PLANS')
            .then((res) => {
              res.unshift({name: "Select an option"});
              this.packages = res;
              console.log("this.packages : ", this.packages.data);
            })
            .catch(err => {
              console.log("API error : ", err);
            }),
            (err) => {
              console.log("err : ", err);
            }
        }
    },
    computed:{
        routeName () {
            const {name} = this.$route;
            return this.capitalizeFirstLetter(name);
        }
    },

    created() {
      this.fetchCorporations();
      this.fetchPackages();
    },
    watch: {
      type (value) {
        if(value == 1) {
          this.corporationsList = this.corporations.filter((obj) => {
            return obj.name !== 'Individual'
          })
        }
        else if(value == 0){
          this.corporationsList = this.corporations.filter((obj) => {
            return obj.name === 'Individual'
          })
        }
      }
    },


    }
</script>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Gifts/CreateGift.vue